import React from "react";
import LIcon from "@components/LIcon";
import { presentIntercomSupport } from "@utils/presentIntercomSupport";

const HelpButton = () => {
  return (
    <LIcon
      colors={{ color: "#F6B452" }}
      sentryEventName="settings_show_intercom"
      name="help"
      size={32}
      onPress={async () => {
        await presentIntercomSupport("present-intercom-from-topbar-help");
      }}
    />
  );
};

export default HelpButton;
